import React from "react";
import { useNavigate } from "react-router-dom";
import { PrototypeBanner } from "@/components/PrototypeBanner";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#EAF3EF] flex flex-col">
      <PrototypeBanner />
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="bg-white rounded-2xl border border-[#D2E3DB] shadow-sm p-10 max-w-md w-full text-center">
          <div className="mb-6 flex justify-center"><Logo /></div>
          <XCircle className="h-16 w-16 text-[#D99A00] mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-[#102A2A]">Pagamento annullato</h1>
          <p className="text-[#5C6B68] mt-2">Nessun addebito effettuato. La prenotazione resta in attesa di pagamento.</p>
          <Button data-testid="cancel-back-bookings" onClick={() => navigate("/paziente/prenotazioni")} className="mt-6 bg-[#087A73] text-white rounded-xl h-12 px-6 w-full">Le mie prenotazioni</Button>
        </div>
      </div>
    </div>
  );
}
